import React, { Component } from "react";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { Dialog, DialogContent } from "@formant/ui-kit";
import { SearchField } from "@formant/ui/component/picker/SearchField";
import { animate } from "@formant/ui/utils/animate";

import { appStore } from "../../../stores";
import { Hotkey } from "../../common/hotkey/Hotkey";
import * as styles from "./index.scss";
import { Suggestions } from "./Suggestions";

@observer
export class JumpPopup extends Component<
    { close: () => void },
    Record<string, never>
> {
    @observable
    private query: string = "";

    public render() {
        const { query, onClose, onHotkey } = this;
        const { close } = this.props;

        return (
            <>
                <Dialog
                    open={appStore.jump}
                    onOpenChange={open => {
                        if (!open) {
                            void onClose();
                        }
                    }}
                >
                    <DialogContent
                        className="bg-formant-color-background-surface border-formant-color-border-active border border-solid rounded-md"
                        showCloseButton={false}
                    >
                        <div className={styles["search-container"]}>
                            <SearchField
                                value={query}
                                onChange={this.onChangeQuery}
                                placeholder="Search for devices, channels, etc."
                                className="search-bar"
                            />
                        </div>

                        <Suggestions
                            query={query}
                            onClose={() => {
                                close();
                                void onClose();
                            }}
                        />
                    </DialogContent>
                </Dialog>
                <Hotkey code="shift+j" onHotkey={onHotkey} label="Jump" />
            </>
        );
    }

    private onChangeQuery = (value: string) => {
        this.query = value;
    };

    private onClose = async () => {
        appStore.jump = false;
        await animate();
        this.query = "";
    };

    private onHotkey = () => {
        appStore.jump = !appStore.jump;
    };
}
